// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__SU5nv","title":"Images45_title___0QBQ","images":"Images45_images__2Tejn"};